import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .7,
			y: 2.56682,
			width: 12.6,
			height: 10.7333,
			rx: 1.3,
			stroke: "#808080",
			strokeWidth: 1.4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .93457,
			y1: 5.83345,
			x2: 13.0679,
			y2: 5.83345,
			stroke: "#808080",
			strokeWidth: 1.4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3.49785,
			x2: 3.49785,
			y2: 1.86667,
			stroke: "#808080",
			strokeWidth: 1.4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10.9676,
			x2: 10.9676,
			y2: 1.86667,
			stroke: "#808080",
			strokeWidth: 1.4
		})
	]
});
export default SvgFilterCalendar;
